









































































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, MTablehelper, DeviceHelper, confirmationHelper } from '@/mixins';
import {
  DocuSignTemplateModel,
  BaseResultModel,
  ScriveTemplateConfigurationModel,
  ArenaSignTemplateCreateUpdateModel,
  Dictionary,
  Configuration,
  ScriveTemplateSigningPartyModel
} from '@/types';
import { TableStateFields } from '@/types/constants/TableConstants';
import { RouteRegEx } from '@/types/enums';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';

export default Vue.extend({
  name: 'ScriveEditTemplate',
  mixins: [FormFieldValidation, RouteHelpers, MTablehelper, DeviceHelper, confirmationHelper],
  data() {
    return {
      isLoading: true,
      docuSignTemplate: {} as DocuSignTemplateModel,
      scriveTemplateConfigurationModel: {} as ScriveTemplateConfigurationModel,
      fields: [
        {
          description: {
            label: 'Description',
            sortable: true
          }
        },
        {
          signerRoleDescription: {
            label: 'Signer Role',
            sortable: true
          }
        },

        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as ScriveTemplateSigningPartyModel[],
      submitIsLoading: false,
      hasError: false,
      tableStateKey: MTablehelper.Constants.TableStoreKeys.ScriveEditTemplate,
      signingPartiesClass: ''
    };
  },
  methods: {
    async initialise(this: any) {
      this.resetViewState();
      await this.getTemplateAsync();
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.ScriveSigningParties);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;

        const result: BaseResultModel = await ScriveConfigurationService.updateTemplateAsync(
          this.docuSignTemplate.id,
          {
            documentTypeId: this.docuSignTemplate.documentTypeId,
            template: this.docuSignTemplate.template
          } as ArenaSignTemplateCreateUpdateModel
        );

        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }

        this.submitIsLoading = false;
        SnotifyConfiguration.showSuccess('Template updated successfully.');
      } catch (error) {
        this.$log('Error updating template', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getTemplateAsync(this: any) {
      this.resetFormValidation();
      this.isLoading = true;
      try {
        this.scriveTemplateConfigurationModel = await ScriveConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: this.templateId
        });
        this.docuSignTemplate = this.scriveTemplateConfigurationModel.template;
        this.items = this.scriveTemplateConfigurationModel.template.templateSigningParties;
      } catch (error) {
        this.docuSignTemplate = {} as DocuSignTemplateModel;
        this.$log('Error getting template');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToTemplateTabManagement();
    },
    async onDeleteSigningPartyAsync(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(
        this.$bvModal,
        'Are you sure you want to delete this signing party?'
      );
      if (result) {
        this.isLoading = true;
        try {
          await ScriveConfigurationService.deleteSigningPartyAsync(id);
          SnotifyConfiguration.showSuccess('Signing party deleted successfully.');
          await this.getTemplateAsync();
        } catch {
          this.$log('Error deleting Signing Party');
        } finally {
          this.isLoading = false;
        }
      }
    },
    navigateToTemplateTabManagement(this: any) {
      this.navigateToRoute(Configuration.Scrive.Template.Management.name, this.documentTypeId);
    },
    navigateToEditSigningParty(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: Configuration.Scrive.SigningParty.Edit.name,
        params: param
      });
    },
    navigateToAddSigningParty(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.Scrive.SigningParty.Add.name,
        params: param
      });
    }
  },
  computed: {
    tableStateFields() {
      return TableStateFields;
    },
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.docuSignTemplate?.template ? `Edit Template (${this.docuSignTemplate.template})` : 'Edit Template';
    },
    signHereCount(this: any) {
      const count = this.docuSignTemplate?.templateSignHeres ? this.docuSignTemplate?.templateSignHeres.length : 0;
      return count > 0 ? count : '';
    },
    additionalDocumentCount(this: any) {
      const count = this.docuSignTemplate?.additionalDocuments
        ? this.docuSignTemplate?.additionalDocuments.length
        : 0;
      return count > 0 ? count : '';
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  components: {
    LoadingSpinner,
    MStoreTable
  }
});
